import { FC, JSX, useEffect, useRef, useState } from 'react';

import { Button, Flex, Form } from 'antd';
import ReactSignatureCanvas from 'react-signature-canvas';

import useIsDesktop from '@/hooks/useIsDesktop';

import styles from './DebtsSignature.module.scss';

import { DebtsSignatureCanvas } from '../debts-signature-canvas';
import { DebtsSignatureModal } from '../debts-signature-modal';

export const DebtsSignature: FC = (): JSX.Element => {
	const sigRef = useRef<ReactSignatureCanvas | null>(null);
	const containerRef = useRef<HTMLDivElement | null>(null);

	const form = Form.useFormInstance();
	const isDesktop = useIsDesktop();

	const [canvasWidth, setCanvasWidth] = useState(400);
	const [isModalOpen, setIsModalOpen] = useState(false);

	const signature = Form.useWatch(['borrowerSignature', 'signature']);

	useEffect(() => {
		const updateWidth = (): void => {
			if (containerRef.current) {
				setCanvasWidth(containerRef.current.offsetWidth);
			}
		};
		updateWidth();
		window.addEventListener('resize', updateWidth);
		return () => window.removeEventListener('resize', updateWidth);
	}, []);

	const handleClear = (): void => {
		form.setFieldValue(['borrowerSignature', 'signature'], undefined);
		sigRef.current?.clear();
	};

	const handleOpenModal = (): void => {
		if (!isDesktop || isModalOpen) return;

		setIsModalOpen(true);
	};

	const handleSaveSignature = (): void => {
		form.setFieldValue(['borrowerSignature', 'signature'], sigRef.current);
	};

	return (
		<>
			{!isDesktop && (
				<Flex align="center" justify="space-between" style={{ width: '100%' }}>
					<span className={styles['label']}>Signature</span>
					<Button type="default" variant="outlined" onClick={handleClear}>
						Clear
					</Button>
				</Flex>
			)}
			<div ref={containerRef} className={styles['container']} onClick={handleOpenModal}>
				{isDesktop ? (
					<>
						<DebtsSignatureModal
							handleClear={handleClear}
							handleSaveSignature={handleSaveSignature}
							open={isModalOpen}
							onClose={() => setIsModalOpen(false)}
						>
							<DebtsSignatureCanvas canvasProps={{ width: 696, height: 267 }} sigRef={sigRef} />
						</DebtsSignatureModal>
						{sigRef.current?.toDataURL() && signature ? (
							<img className={styles['signature-image']} src={sigRef.current.toDataURL()} />
						) : (
							<span className={styles['signature-placeholder']}>Click to sign</span>
						)}
					</>
				) : (
					<Flex vertical>
						<DebtsSignatureCanvas
							canvasProps={{ width: canvasWidth, height: 127 }}
							handleSaveSignature={handleSaveSignature}
							sigRef={sigRef}
						/>
					</Flex>
				)}
			</div>
		</>
	);
};
